import { FormControl, MenuItem } from '@material-ui/core'
import { useEffect, useState } from 'react'
import toastError from '../../errors/toastError'
import api from '../../services/api'
import SelectInput from '../SelectInput'

const QueueSelectSingle = ({ value, onChange, label }) => {
  const [queues, setQueues] = useState([])

  useEffect(() => {
    const fetchQueues = async () => {
      try {
        const { data } = await api.get('/queue?excludeBot=true')
        setQueues(data)
      } catch (err) {
        toastError(err)
      }
    }

    fetchQueues()
  }, [])

  const handleChange = event => {
    onChange(event.target.value)
  }

  return (
    <FormControl fullWidth margin="dense" variant="outlined">
      <SelectInput
        // select
        label={label || 'Departamento Padrão'}
        value={value || ''}
        onChange={handleChange}
        variant="outlined"
        size="small"
      >
        <MenuItem value="">
          Nenhum
        </MenuItem>
        {queues.map(queue => (
          <MenuItem key={queue.id} value={queue.id}>
            {queue.name}
          </MenuItem>
        ))}
      </SelectInput>
    </FormControl>
  )
}

export default QueueSelectSingle
